export default __webpack_public_path__ + "static/media/logo.633eead0.svg";